<template>
  <span :class="`icon ${disabled ? 'disabled' : 'enabled'}`" @click="onClick" :style="{ color: displayColor, size, cursor, ...customStyle }">
    <el-tooltip v-if="displayTitle" placement="top" :content="displayTitle">
      <i :class="icon" :style="{ fontSize: size }" />
    </el-tooltip>
    <i v-else :class="icon" />
  </span>
</template>

<script>
import { Colors } from '@/constants/DoITConstant.js'

export default {
  name: 'FAIcon',
  props: {
    customStyle: {
      type: Object,
      default: () => ({}),
    },
    icon: {
      type: String,
      default: 'fas fa-question',
    },
    title: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: Colors.BLACK,
    },
    size: {
      type: String,
      default: 'inherit',
    },
    clickable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cursor() {
      return (this.title && this.clickable && !this.disabled) ? 'pointer' : 'unset'
    },
    displayColor(){
      return this.disabled ? Colors.DISABLED : this.color
    },
    displayTitle(){
      return (this.title && this.disabled) ? "Bạn không có quyền thực hiện chức năng này" : this.title
    }
  },
  methods: {
    onClick(){
      if (this.disabled) return
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.icon {
  margin-right: 5px;
  display: inline-flex;
  align-items: center;
}
</style>
